import styled from "styled-components";
import * as zero from '@zero/design-tokens/build/js/variables'

export const Container = styled.div`
    font-family: ${zero.ZrFontFamilyDigitalRegular};
    font-size: ${zero.ZrFontSizeMicro};
    & ol, span, .separator{
        color: ${zero.ZrColorNeutralDarkest};
    }
    & ol, span, a, .separator{
        font-size: inherit;
    }
    a {
        color: ${zero.ZrColorLinkActive};
        font-weight: ${zero.ZrFontWeightRegular};
        text-decoration: none;
        :hover{
            text-decoration: underline;
        }
    }
`;